import { createSelector } from "reselect";
import { RootState as RS } from "../types";
import { getAllTemplateMetadataById } from "../templateMetadata/selectors";
import { SFavouriteTemplatesSlice } from "./types";
import { TemplateId } from "../../globalTypes";
import typeGuards from "../../type-guards";

const passTemplateId = (state: RS, templateId: TemplateId) => templateId;

export const getFavouriteTemplatesSlice = (
  state: RS
): SFavouriteTemplatesSlice => state.favouriteTemplates;

export const getFavouriteTemplatesById = (state: RS) =>
  getFavouriteTemplatesSlice(state).byTemplateId;

export const getIdsOfFavouriteTemplates = createSelector(
  getFavouriteTemplatesById,
  (templateIds) => Object.keys(templateIds).map(Number)
);

export const getHasAnyFavouriteTemplates = createSelector(
  getIdsOfFavouriteTemplates,
  (favouriteIds) => !!favouriteIds.length
);

export const getIsFetching = (state: RS) =>
  getFavouriteTemplatesSlice(state).isFetching;

export const getIdsOfVisibleFavouriteTopLevelTemplates = createSelector(
  getIdsOfFavouriteTemplates,
  getAllTemplateMetadataById,
  (templateIds, allTemplatesById) =>
    templateIds.filter((id) => {
      const currentTemplate = allTemplatesById[id];
      if (currentTemplate === undefined) return false;

      const { type, visible } = currentTemplate;
      if (!type) return false;

      const { isTopLevel } = typeGuards.forTemplateType;
      return visible && isTopLevel(type);
    })
);

export const makeGetIsTemplateFavourite = () =>
  createSelector(
    getIdsOfFavouriteTemplates,
    passTemplateId,
    (favouriteTemplates, templateId) =>
      favouriteTemplates.map(Number).includes(templateId)
  );
